import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js';
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

// Add Sedra palette constant for clarity
const SEDRA = '#4a274f';

interface Props { monthly: number[] } // length 12
export const RevenueBar: React.FC<Props> = ({ monthly }) => {
  const data = {
    labels: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
    datasets: [
      {
        label: 'Revenue',
        data: monthly,
        backgroundColor: 'rgba(74, 39, 79, 0.9)',
        borderRadius: 6,
        borderSkipped: false,
      },
    ],
  };
  const opts = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (ctx:any) => `$${ctx.parsed.y.toLocaleString()}`,
        },
      },
      legend: { display: false },
    },
    scales: {
      x: { grid:{ display:false }, ticks: { color: '#6b7280' } },
      y: { grid: { color: 'rgba(0,0,0,0.06)' }, ticks:{ color: '#6b7280', callback:(v:any)=>`$${v/1000}k` } },
    },
  };
  return <Bar aria-label="Monthly revenue bar chart" data={data} options={opts} />;
}; 